import { IMetadataAuthoringRule, MetadataAuthoringRule } from '@adaptiva/metadata/common';
import { INotMetadataAuthoringRule } from '../interfaces';

export class NotMetadataAuthoringRule implements INotMetadataAuthoringRule {

	public type: int;

	public child: IMetadataAuthoringRule;

	constructor(_child?: IMetadataAuthoringRule) {
		this.type = MetadataAuthoringRule.NOT;
		if (_child) {
			this.child = _child;
		}
	}
}
